export enum ESubscriptionPlanId {
  annual = 'sl_studio_annual_50',
  monthly = 'sl_studio_monthly_5',
}

export enum ESubscriptionPlanTypeFromPlanId {
  sl_studio_annual_80 = 'annual',
  sl_studio_monthly_8 = 'monthly',
}

export type TSubscriptionPlanType = 'annual' | 'monthly';

export enum ESubscriptionPlanType {
  annual = 'annual',
  monthly = 'monthly',
}
export type TSubscriptionStep = 'choosePlan' | 'payment';
export enum ESubscriptionStep {
  choosePlan = 'choosePlan',
  payment = 'payment',
}

export interface ISubscription {
  id: number;
  subscription_id: string;
  // TODO: list all braintree status
  status: 'Active' | 'Pending' | 'Canceled' | string;
  first_billing_date: Date;
  expires_at: Date;
  created_at: Date;
  updated_at: Date;
  deleted_at: Date;
  is_valid: boolean;
  plan_type: string;
  expires_at_human_friendly: string;
  created_at_human_friendly: string;
  plan_cost: number;
}

export interface ISubscriptionTransaction {
  id: number;
  status: string;
}

export interface ISubscriptionPaymentMethods {
  id: number;
  status: string;
}
export interface ISubscriptionReceipts {

}

export enum ESubscriptionStatus {
  active = 'Active',
  pending = 'Pending',
  canceled = 'Canceled',
}

export interface IPaymentMethod {
  type: string;
  email?: string;
  last4?: string;
}

export type TSubscriptionType = 'pro' | 'ultra';

export interface ICheckoutPlan {
  id: string;
  name: string;
  prices: string;
  logo: string;
  badgeVariation: string;
  badgeText: string;
  perks: string[];
  isExpanded: boolean;
  onSubscribe?: () => void;
}